module.exports = __webpack_public_path__ + "static/media/icon-other-settings-active.caef8ef7.svg";